import { apiGetTheSignal } from "./api/apiGetTheSignal";
import { apiGetSignalsData } from "./api/apiGetSignalsData";
import { apiGetFavouritesSignals } from './api/apiGetFavouritesSignals';
import { apiSendSignalToServer, apiSendChangedSignalToServer } from "./api/apiSendSignalToServer";
import { apiPinSignal } from './api/apiPinSignal';
import { getLastSignals } from "./api/getLastSignals";

const OldSignals = {
  namespaced: true,

  state: { 
    //Словарь сигналов
    data: {},
    //Последние 6 сигналов
    lastSignals: [],
    isLoadingLastSignals: false,
    readyLastSignals: false,
    //Карта отрисовки
    map: [],
    //Ссылка на следующие страницу пагинации
    nextPageLink: null,
    //Готовы ли данные для выдачи
    isReady: false,
    //Запущен ли процесс загрузки данных с сервера
    isLoading: false,
    //Запущен ли процесс загрузки следующей страницы
    isLoadingNextPage: false,
    //Запущен ли процесс загрузки избранного
    isLoadingFavourites: false,
    //Идет ли процесс отправки сигнала на сервер
    isSignalSendLoading: false,
    //Включен ли фильтр 'Избранное'
    isFavouritesEnabled: false,
    //Черновик для сохранения формы
    draftForm: {},
    //ID редактируемого сигнала
    idEditSignal: null,
  },

  actions:{
    //Метод инициализации сигналов
    async initSignals({ state, commit, dispatch }){
      await dispatch('getSignals');
      if (Object.keys(state.data).length === 0) return;
      commit('SET_READY_FLAG');
    },

    //Получаем список сигналов
    async getSignals({ commit }){
      commit('TOGGLE_LOADING_FLAG', true);
      try{
        const data = await apiGetSignalsData();
        commit('CLEAR_DATA');
        commit('SET_DATA', data.results);
        commit('SET_NEW_LINK', data.next);
        commit('SORT_SIGNALS');
      } catch (error) {
        console.error('Ошибка при добавлении нового сигнала:', error);
      } finally{
        commit('TOGGLE_LOADING_FLAG', false);
      }
    },

    //Подгружаем следующие сигналы
    async loadNextSignals({ commit, state }) {
      commit('TOGGLE_LOADING_NEW_PAGE_FLAG', true);
      try{
        const data = await apiGetSignalsData(state.nextPageLink);
        commit('SET_DATA', data.results);
        commit('SET_NEW_LINK', data.next);
      } catch (error) {
        console.error('Ошибка при получении следующих сигналлв:', error);
      } finally{
        commit('TOGGLE_LOADING_NEW_PAGE_FLAG', false);
      }
    },

    //Добавить сигнал
    async addSignal({ commit }, formData){
      commit('TOGGLE_SIGNAL_SEND_LOADING_FLAG', true);
      try {
        const data = await apiSendSignalToServer(formData);
        commit('SET_NEW_SIGNAL', data);
        commit('SORT_SIGNALS');
        commit('UPDATE_DRAFT_FORM', null);
        return data;
      } catch (error) {
        console.error('Ошибка при добавлении сигнала:', error);
        return Promise.reject(error);
      } finally {
        commit('TOGGLE_SIGNAL_SEND_LOADING_FLAG', false);
      }
    },

    //Изменить сигнал
    async changeSignal({ commit, state }, formData){
      commit('TOGGLE_SIGNAL_SEND_LOADING_FLAG', true);
      try {
        const data = await apiSendChangedSignalToServer(formData, state.idEditSignal);
        commit('UPDATE_SIGNAL', data);
        return data;
      } catch (error) {
        console.error('Ошибка при добавлении сигнала:', error);
        return Promise.reject(error);
      } finally {
        commit('TOGGLE_SIGNAL_SEND_LOADING_FLAG', false);
      }
    },

    //Добавить готовый объект сигнала в список
    async getAndAddTheSignal({ commit }, id){
      try {
        const data = await apiGetTheSignal(id);
        commit('SET_NEW_SIGNAL', data);
        return data;
      } catch (error) {
        console.error('Ошибка при получении конкретного сигнала:', error);
        return Promise.reject(error);
      } finally {

      }
    },

    //Закрепить/открепить сигнал
    async pinSignal({ commit, state }, { id }){
      try {
        const methodType = state.data[id].pinned ? 'DELETE' : 'POST';
        const data = await apiPinSignal({ id, methodType });
        commit('PIN_SIGNAL', id);
        commit('SORT_SIGNALS');
        return data;
      } catch (error) {
        console.error('Ошибка при откреплении / прикриплении сигнала:', error);
        return Promise.reject(error);
      }
    },

    //Изменить значение счетчика комментариев
    async updateCommentsCounter({ commit }, { id, count, isAlignValues }){
      if(isAlignValues){
        commit('ALIGN_COMMENTS', id);
      } else if(count){
        commit('UPDATE_COMMENTS_COUNTER', { id, count })
      }
    },

    //Переключить фильтр сигналов
    async toggleFilter({ state, commit, dispatch }){
      if(state.isLoadingFavourites) return;
      commit('TOGGLE_FAVOURITES_LOADING_FLAG', true);
      if(state.isFavouritesEnabled){
        await dispatch('getSignals');
        commit('TOGGLE_FAVOURITES_FLAG', false);
      }else{
        await dispatch('getFavouritesSignals');
        commit('TOGGLE_FAVOURITES_FLAG', true);
      }
      commit('TOGGLE_FAVOURITES_LOADING_FLAG', false);
    },

    //Отобразить только избранные сигналы
    async getFavouritesSignals({ commit }){
      try{
        const data = await apiGetFavouritesSignals();
        commit('CLEAR_DATA');
        commit('SET_DATA', data.results);
        commit('SET_NEW_LINK', data.next);
        commit('SORT_SIGNALS');
        return data
      } catch (error) {
        console.error('Ошибка при получении избранных:', error);
        return Promise.reject(error);
      }
    },

    //Обновить трендовые сигналы
    async updateTrendingSignals({ commit, state }, data){ 
      data.forEach(item => {
        if(state.map.includes(item.id)){
          commit('MAKE_SIGNAL_TRENDING', { id: item.id, status: true });
        }else{
          commit('SET_NEW_SIGNAL', item);
        }
      });
      commit('SORT_SIGNALS');
    },

    //Получить последние сигналы
    async getLastSignals({ commit }) {
      commit('SET_LOADING_LAST_SIGNALS', true);
      try {
        const data = await getLastSignals();
        commit('SET_LAST_SIGNALS', data);
        commit('SET_READY_LAST_SIGNALS', true);
        return data;
      } catch (error) {
        console.error('Ошибка при получении последних сигналов:', error);
        return Promise.reject(error);
      } finally {
        commit('SET_LOADING_LAST_SIGNALS', false);
      }
    },

    //Обновить даннные на актуальные
    async refreshData({ commit }, data){ commit('REFRESH_DATA', data ); },

    //Обновить состояние избранного
    async updateFavourites({ commit }, { status, id }){ commit('CHANGE_FAVOURITES', { status, id }); },

    //Обновить список данных сигналов
    async updateData({ commit }, data){ commit('UPDATE_DATA', data); },

    //Сохранить черновик формы
    async saveDraftForm({ commit }, data){ commit('UPDATE_DRAFT_FORM', data) },

    //Изменить статус live сигнала
    async approveLiveStatus({ commit }, id){ commit('CHANGE_LIVE_STATUS', {id: id, status: true}); },

    //Изменить id редактируемого сигнала
    async updateIdEditSignal({ commit }, id){ commit('CHANGE_ID_EDIT_SIGNAL', id) },
  },

  mutations: {
    //Добавлям данные в хранилище
    SET_DATA(state, { favorites, list }){
      favorites.forEach(signal => {
        if(!state.map.includes(signal.id)){
          state.data[signal.id] = signal;
          state.map.push(signal.id);
        }
      });
      list.forEach(signal => {
        if(!state.map.includes(signal.id)){
          state.data[signal.id] = signal;
          state.map.push(signal.id);
        }
      });
    },

    //Добавить в список новый сигнал
    SET_NEW_SIGNAL(state, signal){
      if(!state.map.includes(signal.id)){
        state.data[signal.id] = signal;
        state.map.unshift(signal.id);
      }
    },

    //Обновляю информацию о реакциях к сигналам
    CHANGE_REACTIONS(state, {object_id, reactions}){
      if (!state.data[object_id]) return;
      state.data[object_id].reactions.is_mine = reactions.is_mine;
      state.data[object_id].reactions.reactions_values = reactions.reactions_values;
    },

    //Обнвоить данные сигналов
    UPDATE_DATA(state, data){
      data.forEach(item => {
        if(!(item.id in state.data)){
          state.data[item.id] = item;
          state.map.unshift(item.id);
        } 
      })
    },

    //Обновляем счетчик комментариев
    UPDATE_COMMENTS_COUNTER(state, { id, count }){
      if(!state.data[id]) return;
      state.data[id].comments_count = count;
      if(state.data[id].comments_count < state.data[id].init_comments_count){
        state.data[id].init_comments_count = state.data[id].comments_count;
      }
    },

    //Сортировка сигналов
    SORT_SIGNALS(state) {
      state.map.sort((a, b) => {
        const signalA = state.data[a];
        const signalB = state.data[b];
        const priorityA = Number(signalA.pinned) * 2 + Number(signalA.trending);
        const priorityB = Number(signalB.pinned) * 2 + Number(signalB.trending);
        if (priorityA !== priorityB) return priorityB - priorityA;
        const dateA = new Date(signalA.publication_date || signalA.created_at);
        const dateB = new Date(signalB.publication_date || signalB.created_at);
        return dateB - dateA;
      });
    },

    //Обновить данные на актуальные
    REFRESH_DATA(state, data){
      data.forEach(item => {
        const id = item.id;
        state.data[id].change_1d_usd = item.change_1d_usd;
        state.data[id].change_all_time_percent = item.change_all_time_percent;
        state.data[id].price_usd = item.price_usd;
        state.data[id].start_market_cap = item.start_market_cap;
        state.data[id].start_price_usd = item.start_price_usd;
        state.data[id].coin = item.coin,
        state.data[id].ath = item.ath;
        state.data[id].change_ath = item.change_ath;
        state.data[id].atl = item.atl;
        state.data[id].change_atl = item.change_atl;
      })
    },

    //Обновить сигнал
    UPDATE_SIGNAL(state, updData){
      state.data[updData.id].title = updData.title;
      state.data[updData.id].content = updData.content;
      state.data[updData.id].link = updData.link
      state.data[updData.id].coin = updData.coin;
      state.data[updData.id].images_list = updData.images_list;
    },

    //Очистить данные
    CLEAR_DATA(state){
      state.data = {};
      state.map = [];
      state.nextPageLink = null;
    },

    MAKE_SIGNAL_TRENDING(state, { id, status }){ state.data[id].trending = status },

    //Прикрепить / открепить сигнал
    PIN_SIGNAL(state, id){ state.data[id].pinned = !state.data[id].pinned; },

    //Отмечаем, что данные сигналов готовы к использованию
    SET_READY_FLAG(state){ state.isReady = true; },
    
    //Отмечаем, что начался/закончился процесс получения данных с сервера
    TOGGLE_LOADING_FLAG(state, status){ state.isLoading = status; },

    //Отмечаем, что начался/закончился процесс получения новых данных с сервера
    TOGGLE_LOADING_NEW_PAGE_FLAG(state, status){ state.isLoadingNextPage = status; },

    //Отмечаем, что начался/закончился процесс отправки данных сигнала на сервер
    TOGGLE_SIGNAL_SEND_LOADING_FLAG(state, status){ state.isSignalSendLoading = status; },

    //Отмечаем, что начался/закончился процесс получения избранных сигналов
    TOGGLE_FAVOURITES_LOADING_FLAG(state, status){ state.isLoadingFavourites = status; },
    
    //Переключить флаг активации фильтра 'избранного' 
    TOGGLE_FAVOURITES_FLAG(state, status){ state.isFavouritesEnabled = status; },

    //Изменить статс избранного для сигнала
    CHANGE_FAVOURITES(state, {status, id}){ state.data[id].reactions.bookmarked.is_mine = status; },

    //Указать ссылку на следующую страницу
    SET_NEW_LINK(state, link){ state.nextPageLink = link; },

    //Сохраняем черновик формы
    UPDATE_DRAFT_FORM(state, data){ state.draftForm = data; },

    //Изменит статус LIVE сигнала
    CHANGE_LIVE_STATUS(state, {id, status}){ state.data[id].live = status; },

    //Выровнять кол-во комментариев с начальным количеством
    ALIGN_COMMENTS(state, id){ state.data[id].init_comments_count = state.data[id].comments_count; },

    //Изменить ID редактируемого сигнала
    CHANGE_ID_EDIT_SIGNAL(state, id){ state.idEditSignal = id ? id : null },

    //Положить последние сигналы
    SET_LAST_SIGNALS(state, data){ state.lastSignals = data; },

    //Установить флаг загрузки последних сигналов
    SET_LOADING_LAST_SIGNALS(state, status) {
      state.isLoadingLastSignals = status;
    },

    //Установить флаг готовности последних сигналов
    SET_READY_LAST_SIGNALS(state, status) {
      state.readyLastSignals = status;
    },
  },
}

export default OldSignals;